import template from './form.html';
import {FormController} from './form.controller.js';

const FormComponent = {
    restrict: 'E',
    templateUrl: template,
    controller: FormController,
    controllerAs: 'vm',
    bindings: {
        model: '<',
        onSubmit: '&',
        onCancel: '&'
    }
};

export {FormComponent};



// WEBPACK FOOTER //
// ./app/components/pristanak/form/form.js